// DO NOT EDIT -- generated from fs/services/search-settings/adminservice.proto

import { SuggestionRecord } from './namedelements.proto';
import * as protobuf from '../../../google/protobuf';

export namespace AdminService {

  export const BackfillCountsEndpoint = "/grpc/search_settings.AdminService/BackfillCounts";
  export function BackfillCounts(sender: (req: BackfillCountsRequest, endpoint: string) => Promise<BackfillCountsResponse>, req: BackfillCountsRequest): { promise: () => Promise<BackfillCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BackfillCountsEndpoint),
      endpoint: BackfillCountsEndpoint
    };
  }

  export const VerifyCountsEndpoint = "/grpc/search_settings.AdminService/VerifyCounts";
  export function VerifyCounts(sender: (req: VerifyCountsRequest, endpoint: string) => Promise<VerifyCountsResponse>, req: VerifyCountsRequest): { promise: () => Promise<VerifyCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, VerifyCountsEndpoint),
      endpoint: VerifyCountsEndpoint
    };
  }

  export const DeleteSuggestedElementEndpoint = "/grpc/search_settings.AdminService/DeleteSuggestedElement";
  export function DeleteSuggestedElement(sender: (req: DeleteSuggestedElementRequest, endpoint: string) => Promise<DeleteSuggestedElementResponse>, req: DeleteSuggestedElementRequest): { promise: () => Promise<DeleteSuggestedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSuggestedElementEndpoint),
      endpoint: DeleteSuggestedElementEndpoint
    };
  }
}

export interface DeleteSuggestedElementRequest {
  orgId: string;
  elementId: string;
}

export interface DeleteSuggestedElementResponse {
  suggestion: SuggestionRecord | null;
}

export enum Type {
  TYPE_INVALID = 0,
  TYPE_ELEMENT = 1,
  TYPE_EVENT = 2
}

export interface BackfillCountsRequest {
  orgId: string;
  type: Type;
}

export interface BackfillCountsResponse {
  count: protobuf.int64;
  /** whether the count is over the limit, this would not result in a backfill */
  overLimit: boolean;
}

export interface VerifyCountsRequest {
  orgId: string;
  type: Type;
}

export interface VerifyCountsResponse {
  storedCount: protobuf.int64;
  actualCount: protobuf.int64;
}
